"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v4.4.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehiclesApi = exports.VehiclesApiFactory = exports.VehiclesApiFp = exports.VehiclesApiAxiosParamCreator = exports.StationsApi = exports.StationsApiFactory = exports.StationsApiFp = exports.StationsApiAxiosParamCreator = exports.ConversionTrackingApi = exports.ConversionTrackingApiFactory = exports.ConversionTrackingApiFp = exports.ConversionTrackingApiAxiosParamCreator = exports.BookingsApi = exports.BookingsApiFactory = exports.BookingsApiFp = exports.BookingsApiAxiosParamCreator = exports.Api1Api = exports.Api1ApiFactory = exports.Api1ApiFp = exports.Api1ApiAxiosParamCreator = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = exports.ETrackingEvent = exports.ESyncTable = exports.EStatusCode = exports.EPaymentStatus = exports.ENewRegulationCode = exports.EErrorCode = exports.EBookingStep = exports.EBookingStatus = exports.CustomerType = exports.ACPMPriceType = void 0;
var tslib_1 = require("tslib");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var ACPMPriceType;
(function (ACPMPriceType) {
    ACPMPriceType[ACPMPriceType["NUMBER_0"] = 0] = "NUMBER_0";
    ACPMPriceType[ACPMPriceType["NUMBER_1"] = 1] = "NUMBER_1";
    ACPMPriceType[ACPMPriceType["NUMBER_3"] = 3] = "NUMBER_3";
    ACPMPriceType[ACPMPriceType["NUMBER_4"] = 4] = "NUMBER_4";
})(ACPMPriceType = exports.ACPMPriceType || (exports.ACPMPriceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["NUMBER_0"] = 0] = "NUMBER_0";
    CustomerType[CustomerType["NUMBER_1"] = 1] = "NUMBER_1";
})(CustomerType = exports.CustomerType || (exports.CustomerType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EBookingStatus;
(function (EBookingStatus) {
    EBookingStatus[EBookingStatus["NUMBER_1"] = 1] = "NUMBER_1";
    EBookingStatus[EBookingStatus["NUMBER_5"] = 5] = "NUMBER_5";
    EBookingStatus[EBookingStatus["NUMBER_6"] = 6] = "NUMBER_6";
    EBookingStatus[EBookingStatus["NUMBER_7"] = 7] = "NUMBER_7";
    EBookingStatus[EBookingStatus["NUMBER_8"] = 8] = "NUMBER_8";
    EBookingStatus[EBookingStatus["NUMBER_9"] = 9] = "NUMBER_9";
    EBookingStatus[EBookingStatus["NUMBER_10"] = 10] = "NUMBER_10";
    EBookingStatus[EBookingStatus["NUMBER_11"] = 11] = "NUMBER_11";
    EBookingStatus[EBookingStatus["NUMBER_12"] = 12] = "NUMBER_12";
    EBookingStatus[EBookingStatus["NUMBER_MINUS_1"] = -1] = "NUMBER_MINUS_1";
})(EBookingStatus = exports.EBookingStatus || (exports.EBookingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EBookingStep;
(function (EBookingStep) {
    EBookingStep["VehiclesAndProducts"] = "VehiclesAndProducts";
    EBookingStep["StationsAndTime"] = "StationsAndTime";
    EBookingStep["Checkout"] = "Checkout";
})(EBookingStep = exports.EBookingStep || (exports.EBookingStep = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EErrorCode;
(function (EErrorCode) {
    EErrorCode[EErrorCode["NUMBER_4097"] = 4097] = "NUMBER_4097";
    EErrorCode[EErrorCode["NUMBER_4098"] = 4098] = "NUMBER_4098";
    EErrorCode[EErrorCode["NUMBER_4099"] = 4099] = "NUMBER_4099";
    EErrorCode[EErrorCode["NUMBER_4100"] = 4100] = "NUMBER_4100";
    EErrorCode[EErrorCode["NUMBER_4101"] = 4101] = "NUMBER_4101";
    EErrorCode[EErrorCode["NUMBER_4102"] = 4102] = "NUMBER_4102";
    EErrorCode[EErrorCode["NUMBER_4103"] = 4103] = "NUMBER_4103";
    EErrorCode[EErrorCode["NUMBER_4104"] = 4104] = "NUMBER_4104";
    EErrorCode[EErrorCode["NUMBER_4105"] = 4105] = "NUMBER_4105";
    EErrorCode[EErrorCode["NUMBER_4106"] = 4106] = "NUMBER_4106";
    EErrorCode[EErrorCode["NUMBER_4107"] = 4107] = "NUMBER_4107";
    EErrorCode[EErrorCode["NUMBER_4108"] = 4108] = "NUMBER_4108";
    EErrorCode[EErrorCode["NUMBER_4110"] = 4110] = "NUMBER_4110";
    EErrorCode[EErrorCode["NUMBER_4111"] = 4111] = "NUMBER_4111";
    EErrorCode[EErrorCode["NUMBER_4112"] = 4112] = "NUMBER_4112";
    EErrorCode[EErrorCode["NUMBER_4113"] = 4113] = "NUMBER_4113";
    EErrorCode[EErrorCode["NUMBER_4114"] = 4114] = "NUMBER_4114";
    EErrorCode[EErrorCode["NUMBER_4115"] = 4115] = "NUMBER_4115";
    EErrorCode[EErrorCode["NUMBER_4116"] = 4116] = "NUMBER_4116";
    EErrorCode[EErrorCode["NUMBER_4117"] = 4117] = "NUMBER_4117";
    EErrorCode[EErrorCode["NUMBER_4118"] = 4118] = "NUMBER_4118";
    EErrorCode[EErrorCode["NUMBER_4119"] = 4119] = "NUMBER_4119";
    EErrorCode[EErrorCode["NUMBER_4120"] = 4120] = "NUMBER_4120";
    EErrorCode[EErrorCode["NUMBER_8193"] = 8193] = "NUMBER_8193";
    EErrorCode[EErrorCode["NUMBER_8201"] = 8201] = "NUMBER_8201";
    EErrorCode[EErrorCode["NUMBER_8202"] = 8202] = "NUMBER_8202";
    EErrorCode[EErrorCode["NUMBER_8449"] = 8449] = "NUMBER_8449";
    EErrorCode[EErrorCode["NUMBER_8450"] = 8450] = "NUMBER_8450";
    EErrorCode[EErrorCode["NUMBER_8451"] = 8451] = "NUMBER_8451";
    EErrorCode[EErrorCode["NUMBER_8452"] = 8452] = "NUMBER_8452";
    EErrorCode[EErrorCode["NUMBER_8453"] = 8453] = "NUMBER_8453";
    EErrorCode[EErrorCode["NUMBER_8454"] = 8454] = "NUMBER_8454";
    EErrorCode[EErrorCode["NUMBER_8455"] = 8455] = "NUMBER_8455";
    EErrorCode[EErrorCode["NUMBER_8456"] = 8456] = "NUMBER_8456";
    EErrorCode[EErrorCode["NUMBER_8457"] = 8457] = "NUMBER_8457";
    EErrorCode[EErrorCode["NUMBER_8458"] = 8458] = "NUMBER_8458";
    EErrorCode[EErrorCode["NUMBER_8459"] = 8459] = "NUMBER_8459";
    EErrorCode[EErrorCode["NUMBER_8460"] = 8460] = "NUMBER_8460";
    EErrorCode[EErrorCode["NUMBER_12291"] = 12291] = "NUMBER_12291";
    EErrorCode[EErrorCode["NUMBER_12294"] = 12294] = "NUMBER_12294";
    EErrorCode[EErrorCode["NUMBER_12801"] = 12801] = "NUMBER_12801";
    EErrorCode[EErrorCode["NUMBER_77837"] = 77837] = "NUMBER_77837";
    EErrorCode[EErrorCode["NUMBER_77838"] = 77838] = "NUMBER_77838";
})(EErrorCode = exports.EErrorCode || (exports.EErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ENewRegulationCode;
(function (ENewRegulationCode) {
    ENewRegulationCode[ENewRegulationCode["NUMBER_1"] = 1] = "NUMBER_1";
    ENewRegulationCode[ENewRegulationCode["NUMBER_2"] = 2] = "NUMBER_2";
    ENewRegulationCode[ENewRegulationCode["NUMBER_3"] = 3] = "NUMBER_3";
    ENewRegulationCode[ENewRegulationCode["NUMBER_4"] = 4] = "NUMBER_4";
    ENewRegulationCode[ENewRegulationCode["NUMBER_5"] = 5] = "NUMBER_5";
})(ENewRegulationCode = exports.ENewRegulationCode || (exports.ENewRegulationCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EPaymentStatus;
(function (EPaymentStatus) {
    EPaymentStatus[EPaymentStatus["NUMBER_1"] = 1] = "NUMBER_1";
    EPaymentStatus[EPaymentStatus["NUMBER_2"] = 2] = "NUMBER_2";
    EPaymentStatus[EPaymentStatus["NUMBER_3"] = 3] = "NUMBER_3";
    EPaymentStatus[EPaymentStatus["NUMBER_5"] = 5] = "NUMBER_5";
    EPaymentStatus[EPaymentStatus["NUMBER_6"] = 6] = "NUMBER_6";
    EPaymentStatus[EPaymentStatus["NUMBER_7"] = 7] = "NUMBER_7";
})(EPaymentStatus = exports.EPaymentStatus || (exports.EPaymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EStatusCode;
(function (EStatusCode) {
    EStatusCode[EStatusCode["NUMBER_0"] = 0] = "NUMBER_0";
    EStatusCode[EStatusCode["NUMBER_1"] = 1] = "NUMBER_1";
    EStatusCode[EStatusCode["NUMBER_2"] = 2] = "NUMBER_2";
    EStatusCode[EStatusCode["NUMBER_3"] = 3] = "NUMBER_3";
})(EStatusCode = exports.EStatusCode || (exports.EStatusCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ESyncTable;
(function (ESyncTable) {
    ESyncTable[ESyncTable["NUMBER_0"] = 0] = "NUMBER_0";
    ESyncTable[ESyncTable["NUMBER_1"] = 1] = "NUMBER_1";
    ESyncTable[ESyncTable["NUMBER_2"] = 2] = "NUMBER_2";
})(ESyncTable = exports.ESyncTable || (exports.ESyncTable = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ETrackingEvent;
(function (ETrackingEvent) {
    ETrackingEvent["Purchase"] = "Purchase";
    ETrackingEvent["InitiateCheckout"] = "InitiateCheckout";
    ETrackingEvent["Schedule"] = "Schedule";
    ETrackingEvent["FindLocation"] = "FindLocation";
    ETrackingEvent["CustomizeProduct"] = "CustomizeProduct";
    ETrackingEvent["SubmitApplication"] = "SubmitApplication";
    ETrackingEvent["ViewContent"] = "ViewContent";
})(ETrackingEvent = exports.ETrackingEvent || (exports.ETrackingEvent = {}));
/**
 * AccountApi - axios parameter creator
 * @export
 */
var AccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Creates a new user without a password and returns a API key that can be used to retrieve a JWT token
         * @param {RegisterUserDto} [registerUserDto] User info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (registerUserDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerUserDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Getting all deleted userIds that are deleted after a given date
         * @param {string} [fromDate] The date to get the deleted users from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedUsers: function (fromDate, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/deletedUsers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (fromDate !== undefined) {
                                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString() :
                                    fromDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint opens up a session for authenticating the user with bank id
         * @param {string} [personalNumber] Personal number of the user
         * @param {boolean} [thisDevice] If the bank id should be used on the same device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateBankIdLogin: function (personalNumber, thisDevice, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/login/bankid";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (personalNumber !== undefined) {
                                localVarQueryParameter['personalNumber'] = personalNumber;
                            }
                            if (thisDevice !== undefined) {
                                localVarQueryParameter['thisDevice'] = thisDevice;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint checked if the user has a valid authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isLoggedIn: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/isLoggedIn";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Performs a login on the user and returns a JWT token to be used in the coming requests
         * @param {LoginDto} [loginDto] Login credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithApiKey: function (key, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/login/apiKey";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (key !== undefined) {
                                localVarQueryParameter['key'] = key;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary The endpoint retrieves a JWT after the user have succeeded the authentication with BankID
         * @param {string} [sessionId] Session id received when initiating the bank id authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSessionId: function (sessionId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/login/bankid";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (sessionId !== undefined) {
                                localVarQueryParameter['sessionId'] = sessionId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint renews the session of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewSession: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/account/renewSession";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Requests a new password for the customer
         * @param {RestorePasswordModel} restorePasswordModel The form to fill in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewPassword: function (restorePasswordModel, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'restorePasswordModel' is not null or undefined
                            (0, common_1.assertParamExists)('requestNewPassword', 'restorePasswordModel', restorePasswordModel);
                            localVarPath = "/api/account/requestNewPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(restorePasswordModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sets the email and phone of the user
         * @param {string} email The email to set
         * @param {string} phone The phone number to set
         * @param {boolean} [blockMarketing] If the user does not want to get marketing sent to the email and phone associated with the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserInfo: function (email, phone, blockMarketing, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'email' is not null or undefined
                            (0, common_1.assertParamExists)('setUserInfo', 'email', email);
                            // verify required parameter 'phone' is not null or undefined
                            (0, common_1.assertParamExists)('setUserInfo', 'phone', phone);
                            localVarPath = "/api/account/UserInfo";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (email !== undefined) {
                                localVarQueryParameter['email'] = email;
                            }
                            if (phone !== undefined) {
                                localVarQueryParameter['phone'] = phone;
                            }
                            if (blockMarketing !== undefined) {
                                localVarQueryParameter['blockMarketing'] = blockMarketing;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
/**
 * AccountApi - functional programming interface
 * @export
 */
var AccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Creates a new user without a password and returns a API key that can be used to retrieve a JWT token
         * @param {RegisterUserDto} [registerUserDto] User info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (registerUserDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccount(registerUserDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Getting all deleted userIds that are deleted after a given date
         * @param {string} [fromDate] The date to get the deleted users from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedUsers: function (fromDate, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeletedUsers(fromDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint opens up a session for authenticating the user with bank id
         * @param {string} [personalNumber] Personal number of the user
         * @param {boolean} [thisDevice] If the bank id should be used on the same device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateBankIdLogin: function (personalNumber, thisDevice, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.initiateBankIdLogin(personalNumber, thisDevice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint checked if the user has a valid authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isLoggedIn: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.isLoggedIn(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Performs a login on the user and returns a JWT token to be used in the coming requests
         * @param {LoginDto} [loginDto] Login credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.login(loginDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithApiKey: function (key, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginWithApiKey(key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary The endpoint retrieves a JWT after the user have succeeded the authentication with BankID
         * @param {string} [sessionId] Session id received when initiating the bank id authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSessionId: function (sessionId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginWithSessionId(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint renews the session of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewSession: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.renewSession(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Requests a new password for the customer
         * @param {RestorePasswordModel} restorePasswordModel The form to fill in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewPassword: function (restorePasswordModel, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.requestNewPassword(restorePasswordModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sets the email and phone of the user
         * @param {string} email The email to set
         * @param {string} phone The phone number to set
         * @param {boolean} [blockMarketing] If the user does not want to get marketing sent to the email and phone associated with the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserInfo: function (email, phone, blockMarketing, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setUserInfo(email, phone, blockMarketing, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 * @export
 */
var AccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountApiFp)(configuration);
    return {
        /**
         *
         * @summary Creates a new user without a password and returns a API key that can be used to retrieve a JWT token
         * @param {RegisterUserDto} [registerUserDto] User info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (registerUserDto, options) {
            return localVarFp.createAccount(registerUserDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Getting all deleted userIds that are deleted after a given date
         * @param {string} [fromDate] The date to get the deleted users from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeletedUsers: function (fromDate, options) {
            return localVarFp.getDeletedUsers(fromDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint opens up a session for authenticating the user with bank id
         * @param {string} [personalNumber] Personal number of the user
         * @param {boolean} [thisDevice] If the bank id should be used on the same device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateBankIdLogin: function (personalNumber, thisDevice, options) {
            return localVarFp.initiateBankIdLogin(personalNumber, thisDevice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint checked if the user has a valid authorization token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isLoggedIn: function (options) {
            return localVarFp.isLoggedIn(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Performs a login on the user and returns a JWT token to be used in the coming requests
         * @param {LoginDto} [loginDto] Login credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: function (loginDto, options) {
            return localVarFp.login(loginDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [key]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithApiKey: function (key, options) {
            return localVarFp.loginWithApiKey(key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary The endpoint retrieves a JWT after the user have succeeded the authentication with BankID
         * @param {string} [sessionId] Session id received when initiating the bank id authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSessionId: function (sessionId, options) {
            return localVarFp.loginWithSessionId(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint renews the session of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewSession: function (options) {
            return localVarFp.renewSession(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Requests a new password for the customer
         * @param {RestorePasswordModel} restorePasswordModel The form to fill in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewPassword: function (restorePasswordModel, options) {
            return localVarFp.requestNewPassword(restorePasswordModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint sets the email and phone of the user
         * @param {string} email The email to set
         * @param {string} phone The phone number to set
         * @param {boolean} [blockMarketing] If the user does not want to get marketing sent to the email and phone associated with the account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserInfo: function (email, phone, blockMarketing, options) {
            return localVarFp.setUserInfo(email, phone, blockMarketing, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Creates a new user without a password and returns a API key that can be used to retrieve a JWT token
     * @param {RegisterUserDto} [registerUserDto] User info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.createAccount = function (registerUserDto, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).createAccount(registerUserDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Getting all deleted userIds that are deleted after a given date
     * @param {string} [fromDate] The date to get the deleted users from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getDeletedUsers = function (fromDate, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).getDeletedUsers(fromDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint opens up a session for authenticating the user with bank id
     * @param {string} [personalNumber] Personal number of the user
     * @param {boolean} [thisDevice] If the bank id should be used on the same device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.initiateBankIdLogin = function (personalNumber, thisDevice, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).initiateBankIdLogin(personalNumber, thisDevice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint checked if the user has a valid authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.isLoggedIn = function (options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).isLoggedIn(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Performs a login on the user and returns a JWT token to be used in the coming requests
     * @param {LoginDto} [loginDto] Login credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.login = function (loginDto, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).login(loginDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [key]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.loginWithApiKey = function (key, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).loginWithApiKey(key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary The endpoint retrieves a JWT after the user have succeeded the authentication with BankID
     * @param {string} [sessionId] Session id received when initiating the bank id authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.loginWithSessionId = function (sessionId, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).loginWithSessionId(sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint renews the session of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.renewSession = function (options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).renewSession(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Requests a new password for the customer
     * @param {RestorePasswordModel} restorePasswordModel The form to fill in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.requestNewPassword = function (restorePasswordModel, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).requestNewPassword(restorePasswordModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint sets the email and phone of the user
     * @param {string} email The email to set
     * @param {string} phone The phone number to set
     * @param {boolean} [blockMarketing] If the user does not want to get marketing sent to the email and phone associated with the account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.setUserInfo = function (email, phone, blockMarketing, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).setUserInfo(email, phone, blockMarketing, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountApi;
}(base_1.BaseAPI));
exports.AccountApi = AccountApi;
/**
 * Api1Api - axios parameter creator
 * @export
 */
var Api1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary This endpoint cancels a confirmed booking
         * @param {string} bookingNumber The booking number of the booking to be canceled
         * @param {number} [refundById] The refunded by Id
         * @param {string} [bankAccountInfo] Optional bankaccount info on refunds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTheBooking: function (bookingNumber, refundById, bankAccountInfo, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('cancelTheBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/Api1";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (bookingNumber !== undefined) {
                                localVarQueryParameter['bookingNumber'] = bookingNumber;
                            }
                            if (refundById !== undefined) {
                                localVarQueryParameter['refundById'] = refundById;
                            }
                            if (bankAccountInfo !== undefined) {
                                localVarQueryParameter['bankAccountInfo'] = bankAccountInfo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to clone a klarna order for testing purposes
         * @param {string} orderId Klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneKlarnaOrder: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('cloneKlarnaOrder', 'orderId', orderId);
                            localVarPath = "/api/Api1/cloneOrder/{orderId}"
                                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint updates captures with confirmation data after they have been synced
         * @param {KlarnaSyncConfirmation} [klarnaSyncConfirmation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCaptureSync: function (klarnaSyncConfirmation, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/Captures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(klarnaSyncConfirmation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to fix missing klarna Captures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixMissingCaptures: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/FixMissingCaptures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to fix missing klarna Captures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixMissingRefunds: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/FixMissingRefunds";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves AviPayments that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAviPaymentsToSync: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/AviPayments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves klarna captures that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapturesToSync: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/Captures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} bookingNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewBookingPayments: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getNewBookingPayments', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/Api1/NewBookingPayments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (bookingNumber !== undefined) {
                                localVarQueryParameter['bookingNumber'] = bookingNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves klarna Refunds that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefundsToSync: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/Refunds";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint Sets the ns status on the given transactions
         * @param {number} [status]
         * @param {ESyncTable} [table]
         * @param {Array<number>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNsStatus: function (status, table, requestBody, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/Status";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (table !== undefined) {
                                localVarQueryParameter['table'] = table;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to sync klarna orders that are failed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFailedKlarnaBookings: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/SyncFailedKlarnaBookings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to sync a klarna order that is stuck
         * @param {string} orderId Klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncKlarnaOrder: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('syncKlarnaOrder', 'orderId', orderId);
                            localVarPath = "/api/Api1/klarnaSync/{orderId}"
                                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to sync klarna orders that are stuck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStuckUnpaidBookings: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/SyncStuckUnpaidBookings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves klarna captures that are to be synced
         * @param {Array<AviPaymentDto>} [aviPaymentDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAviPayments: function (aviPaymentDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/AviPayments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(aviPaymentDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sets the prepaid amount and payment status on a booking
         * @param {string} [bookingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentStatus: function (bookingId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Api1/UpdatePaymentStatus";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (bookingId !== undefined) {
                                localVarQueryParameter['bookingId'] = bookingId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.Api1ApiAxiosParamCreator = Api1ApiAxiosParamCreator;
/**
 * Api1Api - functional programming interface
 * @export
 */
var Api1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.Api1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary This endpoint cancels a confirmed booking
         * @param {string} bookingNumber The booking number of the booking to be canceled
         * @param {number} [refundById] The refunded by Id
         * @param {string} [bankAccountInfo] Optional bankaccount info on refunds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTheBooking: function (bookingNumber, refundById, bankAccountInfo, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelTheBooking(bookingNumber, refundById, bankAccountInfo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to clone a klarna order for testing purposes
         * @param {string} orderId Klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneKlarnaOrder: function (orderId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cloneKlarnaOrder(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint updates captures with confirmation data after they have been synced
         * @param {KlarnaSyncConfirmation} [klarnaSyncConfirmation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCaptureSync: function (klarnaSyncConfirmation, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.confirmCaptureSync(klarnaSyncConfirmation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to fix missing klarna Captures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixMissingCaptures: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fixMissingCaptures(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to fix missing klarna Captures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixMissingRefunds: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.fixMissingRefunds(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves AviPayments that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAviPaymentsToSync: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAviPaymentsToSync(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves klarna captures that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapturesToSync: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCapturesToSync(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} bookingNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewBookingPayments: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNewBookingPayments(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves klarna Refunds that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefundsToSync: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRefundsToSync(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint Sets the ns status on the given transactions
         * @param {number} [status]
         * @param {ESyncTable} [table]
         * @param {Array<number>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNsStatus: function (status, table, requestBody, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setNsStatus(status, table, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to sync klarna orders that are failed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFailedKlarnaBookings: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.syncFailedKlarnaBookings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to sync a klarna order that is stuck
         * @param {string} orderId Klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncKlarnaOrder: function (orderId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.syncKlarnaOrder(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to sync klarna orders that are stuck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStuckUnpaidBookings: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.syncStuckUnpaidBookings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves klarna captures that are to be synced
         * @param {Array<AviPaymentDto>} [aviPaymentDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAviPayments: function (aviPaymentDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAviPayments(aviPaymentDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sets the prepaid amount and payment status on a booking
         * @param {string} [bookingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentStatus: function (bookingId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePaymentStatus(bookingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.Api1ApiFp = Api1ApiFp;
/**
 * Api1Api - factory interface
 * @export
 */
var Api1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.Api1ApiFp)(configuration);
    return {
        /**
         *
         * @summary This endpoint cancels a confirmed booking
         * @param {string} bookingNumber The booking number of the booking to be canceled
         * @param {number} [refundById] The refunded by Id
         * @param {string} [bankAccountInfo] Optional bankaccount info on refunds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTheBooking: function (bookingNumber, refundById, bankAccountInfo, options) {
            return localVarFp.cancelTheBooking(bookingNumber, refundById, bankAccountInfo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to clone a klarna order for testing purposes
         * @param {string} orderId Klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneKlarnaOrder: function (orderId, options) {
            return localVarFp.cloneKlarnaOrder(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint updates captures with confirmation data after they have been synced
         * @param {KlarnaSyncConfirmation} [klarnaSyncConfirmation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmCaptureSync: function (klarnaSyncConfirmation, options) {
            return localVarFp.confirmCaptureSync(klarnaSyncConfirmation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to fix missing klarna Captures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixMissingCaptures: function (options) {
            return localVarFp.fixMissingCaptures(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to fix missing klarna Captures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixMissingRefunds: function (options) {
            return localVarFp.fixMissingRefunds(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves AviPayments that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAviPaymentsToSync: function (options) {
            return localVarFp.getAviPaymentsToSync(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves klarna captures that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapturesToSync: function (options) {
            return localVarFp.getCapturesToSync(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} bookingNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewBookingPayments: function (bookingNumber, options) {
            return localVarFp.getNewBookingPayments(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves klarna Refunds that are to be synced
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefundsToSync: function (options) {
            return localVarFp.getRefundsToSync(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint Sets the ns status on the given transactions
         * @param {number} [status]
         * @param {ESyncTable} [table]
         * @param {Array<number>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNsStatus: function (status, table, requestBody, options) {
            return localVarFp.setNsStatus(status, table, requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to sync klarna orders that are failed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFailedKlarnaBookings: function (options) {
            return localVarFp.syncFailedKlarnaBookings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to sync a klarna order that is stuck
         * @param {string} orderId Klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncKlarnaOrder: function (orderId, options) {
            return localVarFp.syncKlarnaOrder(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to sync klarna orders that are stuck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStuckUnpaidBookings: function (options) {
            return localVarFp.syncStuckUnpaidBookings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves klarna captures that are to be synced
         * @param {Array<AviPaymentDto>} [aviPaymentDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAviPayments: function (aviPaymentDto, options) {
            return localVarFp.updateAviPayments(aviPaymentDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint sets the prepaid amount and payment status on a booking
         * @param {string} [bookingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentStatus: function (bookingId, options) {
            return localVarFp.updatePaymentStatus(bookingId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.Api1ApiFactory = Api1ApiFactory;
/**
 * Api1Api - object-oriented interface
 * @export
 * @class Api1Api
 * @extends {BaseAPI}
 */
var Api1Api = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Api1Api, _super);
    function Api1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary This endpoint cancels a confirmed booking
     * @param {string} bookingNumber The booking number of the booking to be canceled
     * @param {number} [refundById] The refunded by Id
     * @param {string} [bankAccountInfo] Optional bankaccount info on refunds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.cancelTheBooking = function (bookingNumber, refundById, bankAccountInfo, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).cancelTheBooking(bookingNumber, refundById, bankAccountInfo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to clone a klarna order for testing purposes
     * @param {string} orderId Klarna order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.cloneKlarnaOrder = function (orderId, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).cloneKlarnaOrder(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint updates captures with confirmation data after they have been synced
     * @param {KlarnaSyncConfirmation} [klarnaSyncConfirmation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.confirmCaptureSync = function (klarnaSyncConfirmation, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).confirmCaptureSync(klarnaSyncConfirmation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to fix missing klarna Captures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.fixMissingCaptures = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).fixMissingCaptures(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to fix missing klarna Captures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.fixMissingRefunds = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).fixMissingRefunds(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves AviPayments that are to be synced
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.getAviPaymentsToSync = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).getAviPaymentsToSync(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves klarna captures that are to be synced
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.getCapturesToSync = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).getCapturesToSync(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} bookingNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.getNewBookingPayments = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).getNewBookingPayments(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves klarna Refunds that are to be synced
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.getRefundsToSync = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).getRefundsToSync(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint Sets the ns status on the given transactions
     * @param {number} [status]
     * @param {ESyncTable} [table]
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.setNsStatus = function (status, table, requestBody, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).setNsStatus(status, table, requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to sync klarna orders that are failed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.syncFailedKlarnaBookings = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).syncFailedKlarnaBookings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to sync a klarna order that is stuck
     * @param {string} orderId Klarna order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.syncKlarnaOrder = function (orderId, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).syncKlarnaOrder(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to sync klarna orders that are stuck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.syncStuckUnpaidBookings = function (options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).syncStuckUnpaidBookings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves klarna captures that are to be synced
     * @param {Array<AviPaymentDto>} [aviPaymentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.updateAviPayments = function (aviPaymentDto, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).updateAviPayments(aviPaymentDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint sets the prepaid amount and payment status on a booking
     * @param {string} [bookingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Api1Api
     */
    Api1Api.prototype.updatePaymentStatus = function (bookingId, options) {
        var _this = this;
        return (0, exports.Api1ApiFp)(this.configuration).updatePaymentStatus(bookingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return Api1Api;
}(base_1.BaseAPI));
exports.Api1Api = Api1Api;
/**
 * BookingsApi - axios parameter creator
 * @export
 */
var BookingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary This endpoint cancels a confirmed booking
         * @param {string} bookingNumber The booking number of the booking to be canceled
         * @param {string} [bankAccountInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking: function (bookingNumber, bankAccountInfo, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('cancelBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (bankAccountInfo !== undefined) {
                                localVarQueryParameter['bankAccountInfo'] = bankAccountInfo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint initializes a rebooking scenario of a already existing ordinary booking.  It make a temporary copy of the ordinary booking that can me manipulated and later merged in to the original.
         * @param {string} bookingNumber The booking number of the booking to rebook.
         * @param {CloneBookingDto} [cloneBookingDto] Information used for verifying the identity of the customer (email / phone).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneBooking: function (bookingNumber, cloneBookingDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('cloneBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/rebook"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cloneBookingDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint tries to create a new temporary booking, to be filled in with future request.  If a temporary booking already exist, that booking will be returned.  A temporary booking has a lifespan of about 30 minutes. That counter is reset with every action made to the booking
         * @param {CreateBookingDto} createBookingDto The plate number of the first vehicle in the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking: function (createBookingDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createBookingDto' is not null or undefined
                            (0, common_1.assertParamExists)('createBooking', 'createBookingDto', createBookingDto);
                            localVarPath = "/api/bookings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createBookingDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint deletes a uncompleted booking
         * @param {string} bookingNumber The booking number of the temporary booking to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exitBooking: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('exitBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/exit"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the ACPM price for the given parameters
         * @param {string} regno The regNo of the vehicle to get the price for
         * @param {number} productId The id of the product.
         * @param {string} dateTime The start time and date.
         * @param {number} stationId The id of the station.
         * @param {ACPMPriceType} priceTypeId The id of the price type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACPMPrice: function (regno, productId, dateTime, stationId, priceTypeId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getACPMPrice', 'regno', regno);
                            // verify required parameter 'productId' is not null or undefined
                            (0, common_1.assertParamExists)('getACPMPrice', 'productId', productId);
                            // verify required parameter 'dateTime' is not null or undefined
                            (0, common_1.assertParamExists)('getACPMPrice', 'dateTime', dateTime);
                            // verify required parameter 'stationId' is not null or undefined
                            (0, common_1.assertParamExists)('getACPMPrice', 'stationId', stationId);
                            // verify required parameter 'priceTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getACPMPrice', 'priceTypeId', priceTypeId);
                            localVarPath = "/api/bookings/ACPMPrice";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (regno !== undefined) {
                                localVarQueryParameter['regno'] = regno;
                            }
                            if (productId !== undefined) {
                                localVarQueryParameter['productId'] = productId;
                            }
                            if (dateTime !== undefined) {
                                localVarQueryParameter['dateTime'] = (dateTime instanceof Date) ?
                                    dateTime.toISOString() :
                                    dateTime;
                            }
                            if (stationId !== undefined) {
                                localVarQueryParameter['stationId'] = stationId;
                            }
                            if (priceTypeId !== undefined) {
                                localVarQueryParameter['priceTypeId'] = priceTypeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the ACPM price rule texts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACPMPriceRuleTexts: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/bookings/ACPMPriceRuleTexts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets basic information about all available products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/bookings/products";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary The get available products for booking.
         * @param {string} bookingNumber The booking number.
         * @param {string} regno The plate number of the vehicle to display products for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsForBooking: function (bookingNumber, regno, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableProductsForBooking', 'bookingNumber', bookingNumber);
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableProductsForBooking', 'regno', regno);
                            localVarPath = "/api/bookings/{bookingNumber}/vehicles/{regno}/availableProducts"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)))
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the available times for the booking based on the given search parameters
         * @param {string} bookingNumber The booking number of the booking to get the available times for
         * @param {Array<number>} stationIds The station Ids.
         * @param {string} start The start.
         * @param {string} end The end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimesForBooking: function (bookingNumber, stationIds, start, end, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableTimesForBooking', 'bookingNumber', bookingNumber);
                            // verify required parameter 'stationIds' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableTimesForBooking', 'stationIds', stationIds);
                            // verify required parameter 'start' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableTimesForBooking', 'start', start);
                            // verify required parameter 'end' is not null or undefined
                            (0, common_1.assertParamExists)('getAvailableTimesForBooking', 'end', end);
                            localVarPath = "/api/bookings/{bookingNumber}/availableTimes"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (stationIds) {
                                localVarQueryParameter['stationIds'] = stationIds;
                            }
                            if (start !== undefined) {
                                localVarQueryParameter['start'] = (start instanceof Date) ?
                                    start.toISOString() :
                                    start;
                            }
                            if (end !== undefined) {
                                localVarQueryParameter['end'] = (end instanceof Date) ?
                                    end.toISOString() :
                                    end;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves a booking by booking number. The result can be a completed booking, a confirmed future  booking or a ongoing temporary booking.
         * @param {string} bookingNumber The booking number of the booking to retrieve. It has the format (B123456)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBooking: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves a booking by sso key. The result can be a completed booking, a confirmed future booking or  a ongoing temporary booking.
         * @param {string} key The sso key for the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingFromSsoKey: function (key, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'key' is not null or undefined
                            (0, common_1.assertParamExists)('getBookingFromSsoKey', 'key', key);
                            localVarPath = "/api/bookings/sso/{key}"
                                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets dates and status of future bookings of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/bookings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves information about the consequences of cancelling the booking
         * @param {string} bookingNumber The booking number of the booking to get the cancellation info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelBookingInfo: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getCancelBookingInfo', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/cancelInfo"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
         * @param {string} bookingNumber The booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationPrintOut: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getConfirmationPrintOut', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/confirmationPrintOut"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint created ans returns a *.ics file with calendar information about the booking
         * @param {string} bookingNumber The booking number of the booking to base the *.ics file on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getICal: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getICal', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/iCal"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is responsible for retrieving available payment options for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to get the payment options for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentOptions: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getPaymentOptions', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/payment"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary The get stations for booking.
         * @param {string} bookingNumber The booking number.
         * @param {number} [lat] The lat.
         * @param {number} [lon] The lon.
         * @param {number} [radius] The radius to search around. If not assigned it will default to int.Max (aka. All stations)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedStationsForBooking: function (bookingNumber, lat, lon, radius, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('getSuggestedStationsForBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/stations"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (lat !== undefined) {
                                localVarQueryParameter['lat'] = lat;
                            }
                            if (lon !== undefined) {
                                localVarQueryParameter['lon'] = lon;
                            }
                            if (radius !== undefined) {
                                localVarQueryParameter['radius'] = radius;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets the bookings on a specific vehicle both temporary and ordinary
         * @param {string} regno The plate number of the vehicle to match the future booking with.
         * @param {boolean} [ignorePassedBookings] If the search should ignore last bookings
         * @param {boolean} [includeUncompleted] If the response should contain temporary bookings that have been started but not  completed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleBookings: function (regno, ignorePassedBookings, includeUncompleted, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getVehicleBookings', 'regno', regno);
                            localVarPath = "/api/bookings/vehicles/{regno}"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (ignorePassedBookings !== undefined) {
                                localVarQueryParameter['ignorePassedBookings'] = ignorePassedBookings;
                            }
                            if (includeUncompleted !== undefined) {
                                localVarQueryParameter['includeUncompleted'] = includeUncompleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint keeps the time that is currently on the booking, but recalculates the price
         * @param {string} bookingNumber The booking number of the booking to keep the time on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keepTimeForBooking: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('keepTimeForBooking', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/keepTime"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to get the klarna confirmation page snippet
         * @param {string} orderId Klarna order id
         * @param {string} bookingNumber Booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaConfirmation: function (orderId, bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('klarnaConfirmation', 'orderId', orderId);
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('klarnaConfirmation', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/klarnaConfirmation/{orderId}"
                                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)))
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaPushNotification: function (orderId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('klarnaPushNotification', 'orderId', orderId);
                            localVarPath = "/api/bookings/KlarnaPushNotification";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (orderId !== undefined) {
                                localVarQueryParameter['orderId'] = orderId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is responsible for opening up payment for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to open payment for
         * @param {PayBookingDto} payBookingDto Stringfied Json object containing information needed for the chosen payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payBooking: function (bookingNumber, payBookingDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('payBooking', 'bookingNumber', bookingNumber);
                            // verify required parameter 'payBookingDto' is not null or undefined
                            (0, common_1.assertParamExists)('payBooking', 'payBookingDto', payBookingDto);
                            localVarPath = "/api/bookings/{bookingNumber}/payment"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payBookingDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is to be called when a payment failure occured on a booking
         * @param {string} bookingNumber The booking number of the booking that the payment failed on
         * @param {string} [orderId] Klarna order id in case the endpoint is used when a klarna payment failed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentFailed: function (bookingNumber, orderId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('paymentFailed', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/payment/failed"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (orderId !== undefined) {
                                localVarQueryParameter['orderId'] = orderId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
         * @param {string} bookingNumber The booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendConfirmation: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('sendConfirmation', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/sendConfirmation"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoints attempts to att a campaign code to a booking
         * @param {string} bookingNumber The booking number of the booking to edit
         * @param {SetCampaignCodeDto} [setCampaignCodeDto] The campaign code to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCampaignCode: function (bookingNumber, setCampaignCodeDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('setCampaignCode', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/campaignCode"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setCampaignCodeDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used for setting the products for the given booking
         * @param {string} bookingNumber The booking number of the given booking to update
         * @param {SetProducts} setProducts Information about the selected products on the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProducts: function (bookingNumber, setProducts, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('setProducts', 'bookingNumber', bookingNumber);
                            // verify required parameter 'setProducts' is not null or undefined
                            (0, common_1.assertParamExists)('setProducts', 'setProducts', setProducts);
                            localVarPath = "/api/bookings/{bookingNumber}/products"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setProducts, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint selects a time that is previously retrieved with the [GET bookingNumber}/availableTimes]
         * @param {string} bookingNumber The booking number of the booking to select the time for
         * @param {SelectTime} selectTime The time and data info to set to the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeForBooking: function (bookingNumber, selectTime, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('setTimeForBooking', 'bookingNumber', bookingNumber);
                            // verify required parameter 'selectTime' is not null or undefined
                            (0, common_1.assertParamExists)('setTimeForBooking', 'selectTime', selectTime);
                            localVarPath = "/api/bookings/{bookingNumber}/availableTimes"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(selectTime, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is responsible for updating the payment for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to open payment for
         * @param {string} orderId The klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayBooking: function (bookingNumber, orderId, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('updatePayBooking', 'bookingNumber', bookingNumber);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePayBooking', 'orderId', orderId);
                            localVarPath = "/api/bookings/{bookingNumber}/payment/{orderId}"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)))
                                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint extends the life time of the temporary booking
         * @param {string} bookingNumber The booking number of the booking. It has the format (B123456)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession: function (bookingNumber, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bookingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('updateSession', 'bookingNumber', bookingNumber);
                            localVarPath = "/api/bookings/{bookingNumber}/updateSession"
                                .replace("{".concat("bookingNumber", "}"), encodeURIComponent(String(bookingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BookingsApiAxiosParamCreator = BookingsApiAxiosParamCreator;
/**
 * BookingsApi - functional programming interface
 * @export
 */
var BookingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BookingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary This endpoint cancels a confirmed booking
         * @param {string} bookingNumber The booking number of the booking to be canceled
         * @param {string} [bankAccountInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking: function (bookingNumber, bankAccountInfo, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cancelBooking(bookingNumber, bankAccountInfo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint initializes a rebooking scenario of a already existing ordinary booking.  It make a temporary copy of the ordinary booking that can me manipulated and later merged in to the original.
         * @param {string} bookingNumber The booking number of the booking to rebook.
         * @param {CloneBookingDto} [cloneBookingDto] Information used for verifying the identity of the customer (email / phone).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneBooking: function (bookingNumber, cloneBookingDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cloneBooking(bookingNumber, cloneBookingDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint tries to create a new temporary booking, to be filled in with future request.  If a temporary booking already exist, that booking will be returned.  A temporary booking has a lifespan of about 30 minutes. That counter is reset with every action made to the booking
         * @param {CreateBookingDto} createBookingDto The plate number of the first vehicle in the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking: function (createBookingDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBooking(createBookingDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint deletes a uncompleted booking
         * @param {string} bookingNumber The booking number of the temporary booking to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exitBooking: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.exitBooking(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the ACPM price for the given parameters
         * @param {string} regno The regNo of the vehicle to get the price for
         * @param {number} productId The id of the product.
         * @param {string} dateTime The start time and date.
         * @param {number} stationId The id of the station.
         * @param {ACPMPriceType} priceTypeId The id of the price type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACPMPrice: function (regno, productId, dateTime, stationId, priceTypeId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getACPMPrice(regno, productId, dateTime, stationId, priceTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the ACPM price rule texts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACPMPriceRuleTexts: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getACPMPriceRuleTexts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets basic information about all available products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllProducts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary The get available products for booking.
         * @param {string} bookingNumber The booking number.
         * @param {string} regno The plate number of the vehicle to display products for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsForBooking: function (bookingNumber, regno, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailableProductsForBooking(bookingNumber, regno, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the available times for the booking based on the given search parameters
         * @param {string} bookingNumber The booking number of the booking to get the available times for
         * @param {Array<number>} stationIds The station Ids.
         * @param {string} start The start.
         * @param {string} end The end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimesForBooking: function (bookingNumber, stationIds, start, end, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailableTimesForBooking(bookingNumber, stationIds, start, end, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves a booking by booking number. The result can be a completed booking, a confirmed future  booking or a ongoing temporary booking.
         * @param {string} bookingNumber The booking number of the booking to retrieve. It has the format (B123456)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBooking: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBooking(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves a booking by sso key. The result can be a completed booking, a confirmed future booking or  a ongoing temporary booking.
         * @param {string} key The sso key for the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingFromSsoKey: function (key, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBookingFromSsoKey(key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets dates and status of future bookings of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBookings(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves information about the consequences of cancelling the booking
         * @param {string} bookingNumber The booking number of the booking to get the cancellation info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelBookingInfo: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCancelBookingInfo(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
         * @param {string} bookingNumber The booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationPrintOut: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getConfirmationPrintOut(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint created ans returns a *.ics file with calendar information about the booking
         * @param {string} bookingNumber The booking number of the booking to base the *.ics file on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getICal: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getICal(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is responsible for retrieving available payment options for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to get the payment options for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentOptions: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPaymentOptions(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary The get stations for booking.
         * @param {string} bookingNumber The booking number.
         * @param {number} [lat] The lat.
         * @param {number} [lon] The lon.
         * @param {number} [radius] The radius to search around. If not assigned it will default to int.Max (aka. All stations)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedStationsForBooking: function (bookingNumber, lat, lon, radius, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSuggestedStationsForBooking(bookingNumber, lat, lon, radius, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets the bookings on a specific vehicle both temporary and ordinary
         * @param {string} regno The plate number of the vehicle to match the future booking with.
         * @param {boolean} [ignorePassedBookings] If the search should ignore last bookings
         * @param {boolean} [includeUncompleted] If the response should contain temporary bookings that have been started but not  completed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleBookings: function (regno, ignorePassedBookings, includeUncompleted, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVehicleBookings(regno, ignorePassedBookings, includeUncompleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint keeps the time that is currently on the booking, but recalculates the price
         * @param {string} bookingNumber The booking number of the booking to keep the time on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keepTimeForBooking: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.keepTimeForBooking(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used to get the klarna confirmation page snippet
         * @param {string} orderId Klarna order id
         * @param {string} bookingNumber Booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaConfirmation: function (orderId, bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.klarnaConfirmation(orderId, bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaPushNotification: function (orderId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.klarnaPushNotification(orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is responsible for opening up payment for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to open payment for
         * @param {PayBookingDto} payBookingDto Stringfied Json object containing information needed for the chosen payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payBooking: function (bookingNumber, payBookingDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.payBooking(bookingNumber, payBookingDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is to be called when a payment failure occured on a booking
         * @param {string} bookingNumber The booking number of the booking that the payment failed on
         * @param {string} [orderId] Klarna order id in case the endpoint is used when a klarna payment failed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentFailed: function (bookingNumber, orderId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentFailed(bookingNumber, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
         * @param {string} bookingNumber The booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendConfirmation: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendConfirmation(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoints attempts to att a campaign code to a booking
         * @param {string} bookingNumber The booking number of the booking to edit
         * @param {SetCampaignCodeDto} [setCampaignCodeDto] The campaign code to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCampaignCode: function (bookingNumber, setCampaignCodeDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setCampaignCode(bookingNumber, setCampaignCodeDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is used for setting the products for the given booking
         * @param {string} bookingNumber The booking number of the given booking to update
         * @param {SetProducts} setProducts Information about the selected products on the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProducts: function (bookingNumber, setProducts, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setProducts(bookingNumber, setProducts, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint selects a time that is previously retrieved with the [GET bookingNumber}/availableTimes]
         * @param {string} bookingNumber The booking number of the booking to select the time for
         * @param {SelectTime} selectTime The time and data info to set to the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeForBooking: function (bookingNumber, selectTime, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setTimeForBooking(bookingNumber, selectTime, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint is responsible for updating the payment for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to open payment for
         * @param {string} orderId The klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayBooking: function (bookingNumber, orderId, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePayBooking(bookingNumber, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint extends the life time of the temporary booking
         * @param {string} bookingNumber The booking number of the booking. It has the format (B123456)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession: function (bookingNumber, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSession(bookingNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BookingsApiFp = BookingsApiFp;
/**
 * BookingsApi - factory interface
 * @export
 */
var BookingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BookingsApiFp)(configuration);
    return {
        /**
         *
         * @summary This endpoint cancels a confirmed booking
         * @param {string} bookingNumber The booking number of the booking to be canceled
         * @param {string} [bankAccountInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelBooking: function (bookingNumber, bankAccountInfo, options) {
            return localVarFp.cancelBooking(bookingNumber, bankAccountInfo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint initializes a rebooking scenario of a already existing ordinary booking.  It make a temporary copy of the ordinary booking that can me manipulated and later merged in to the original.
         * @param {string} bookingNumber The booking number of the booking to rebook.
         * @param {CloneBookingDto} [cloneBookingDto] Information used for verifying the identity of the customer (email / phone).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneBooking: function (bookingNumber, cloneBookingDto, options) {
            return localVarFp.cloneBooking(bookingNumber, cloneBookingDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint tries to create a new temporary booking, to be filled in with future request.  If a temporary booking already exist, that booking will be returned.  A temporary booking has a lifespan of about 30 minutes. That counter is reset with every action made to the booking
         * @param {CreateBookingDto} createBookingDto The plate number of the first vehicle in the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBooking: function (createBookingDto, options) {
            return localVarFp.createBooking(createBookingDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint deletes a uncompleted booking
         * @param {string} bookingNumber The booking number of the temporary booking to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exitBooking: function (bookingNumber, options) {
            return localVarFp.exitBooking(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves the ACPM price for the given parameters
         * @param {string} regno The regNo of the vehicle to get the price for
         * @param {number} productId The id of the product.
         * @param {string} dateTime The start time and date.
         * @param {number} stationId The id of the station.
         * @param {ACPMPriceType} priceTypeId The id of the price type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACPMPrice: function (regno, productId, dateTime, stationId, priceTypeId, options) {
            return localVarFp.getACPMPrice(regno, productId, dateTime, stationId, priceTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves the ACPM price rule texts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getACPMPriceRuleTexts: function (options) {
            return localVarFp.getACPMPriceRuleTexts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets basic information about all available products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProducts: function (options) {
            return localVarFp.getAllProducts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary The get available products for booking.
         * @param {string} bookingNumber The booking number.
         * @param {string} regno The plate number of the vehicle to display products for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsForBooking: function (bookingNumber, regno, options) {
            return localVarFp.getAvailableProductsForBooking(bookingNumber, regno, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves the available times for the booking based on the given search parameters
         * @param {string} bookingNumber The booking number of the booking to get the available times for
         * @param {Array<number>} stationIds The station Ids.
         * @param {string} start The start.
         * @param {string} end The end.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimesForBooking: function (bookingNumber, stationIds, start, end, options) {
            return localVarFp.getAvailableTimesForBooking(bookingNumber, stationIds, start, end, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves a booking by booking number. The result can be a completed booking, a confirmed future  booking or a ongoing temporary booking.
         * @param {string} bookingNumber The booking number of the booking to retrieve. It has the format (B123456)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBooking: function (bookingNumber, options) {
            return localVarFp.getBooking(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves a booking by sso key. The result can be a completed booking, a confirmed future booking or  a ongoing temporary booking.
         * @param {string} key The sso key for the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingFromSsoKey: function (key, options) {
            return localVarFp.getBookingFromSsoKey(key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets dates and status of future bookings of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookings: function (options) {
            return localVarFp.getBookings(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves information about the consequences of cancelling the booking
         * @param {string} bookingNumber The booking number of the booking to get the cancellation info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelBookingInfo: function (bookingNumber, options) {
            return localVarFp.getCancelBookingInfo(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
         * @param {string} bookingNumber The booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationPrintOut: function (bookingNumber, options) {
            return localVarFp.getConfirmationPrintOut(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint created ans returns a *.ics file with calendar information about the booking
         * @param {string} bookingNumber The booking number of the booking to base the *.ics file on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getICal: function (bookingNumber, options) {
            return localVarFp.getICal(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is responsible for retrieving available payment options for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to get the payment options for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentOptions: function (bookingNumber, options) {
            return localVarFp.getPaymentOptions(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary The get stations for booking.
         * @param {string} bookingNumber The booking number.
         * @param {number} [lat] The lat.
         * @param {number} [lon] The lon.
         * @param {number} [radius] The radius to search around. If not assigned it will default to int.Max (aka. All stations)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedStationsForBooking: function (bookingNumber, lat, lon, radius, options) {
            return localVarFp.getSuggestedStationsForBooking(bookingNumber, lat, lon, radius, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets the bookings on a specific vehicle both temporary and ordinary
         * @param {string} regno The plate number of the vehicle to match the future booking with.
         * @param {boolean} [ignorePassedBookings] If the search should ignore last bookings
         * @param {boolean} [includeUncompleted] If the response should contain temporary bookings that have been started but not  completed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleBookings: function (regno, ignorePassedBookings, includeUncompleted, options) {
            return localVarFp.getVehicleBookings(regno, ignorePassedBookings, includeUncompleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint keeps the time that is currently on the booking, but recalculates the price
         * @param {string} bookingNumber The booking number of the booking to keep the time on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        keepTimeForBooking: function (bookingNumber, options) {
            return localVarFp.keepTimeForBooking(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used to get the klarna confirmation page snippet
         * @param {string} orderId Klarna order id
         * @param {string} bookingNumber Booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaConfirmation: function (orderId, bookingNumber, options) {
            return localVarFp.klarnaConfirmation(orderId, bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        klarnaPushNotification: function (orderId, options) {
            return localVarFp.klarnaPushNotification(orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is responsible for opening up payment for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to open payment for
         * @param {PayBookingDto} payBookingDto Stringfied Json object containing information needed for the chosen payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payBooking: function (bookingNumber, payBookingDto, options) {
            return localVarFp.payBooking(bookingNumber, payBookingDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is to be called when a payment failure occured on a booking
         * @param {string} bookingNumber The booking number of the booking that the payment failed on
         * @param {string} [orderId] Klarna order id in case the endpoint is used when a klarna payment failed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentFailed: function (bookingNumber, orderId, options) {
            return localVarFp.paymentFailed(bookingNumber, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
         * @param {string} bookingNumber The booking number of the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendConfirmation: function (bookingNumber, options) {
            return localVarFp.sendConfirmation(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoints attempts to att a campaign code to a booking
         * @param {string} bookingNumber The booking number of the booking to edit
         * @param {SetCampaignCodeDto} [setCampaignCodeDto] The campaign code to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCampaignCode: function (bookingNumber, setCampaignCodeDto, options) {
            return localVarFp.setCampaignCode(bookingNumber, setCampaignCodeDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is used for setting the products for the given booking
         * @param {string} bookingNumber The booking number of the given booking to update
         * @param {SetProducts} setProducts Information about the selected products on the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProducts: function (bookingNumber, setProducts, options) {
            return localVarFp.setProducts(bookingNumber, setProducts, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint selects a time that is previously retrieved with the [GET bookingNumber}/availableTimes]
         * @param {string} bookingNumber The booking number of the booking to select the time for
         * @param {SelectTime} selectTime The time and data info to set to the booking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setTimeForBooking: function (bookingNumber, selectTime, options) {
            return localVarFp.setTimeForBooking(bookingNumber, selectTime, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint is responsible for updating the payment for the booking with the given booking number
         * @param {string} bookingNumber The booking number of the booking to open payment for
         * @param {string} orderId The klarna order id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePayBooking: function (bookingNumber, orderId, options) {
            return localVarFp.updatePayBooking(bookingNumber, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint extends the life time of the temporary booking
         * @param {string} bookingNumber The booking number of the booking. It has the format (B123456)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession: function (bookingNumber, options) {
            return localVarFp.updateSession(bookingNumber, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BookingsApiFactory = BookingsApiFactory;
/**
 * BookingsApi - object-oriented interface
 * @export
 * @class BookingsApi
 * @extends {BaseAPI}
 */
var BookingsApi = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BookingsApi, _super);
    function BookingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary This endpoint cancels a confirmed booking
     * @param {string} bookingNumber The booking number of the booking to be canceled
     * @param {string} [bankAccountInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.cancelBooking = function (bookingNumber, bankAccountInfo, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).cancelBooking(bookingNumber, bankAccountInfo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint initializes a rebooking scenario of a already existing ordinary booking.  It make a temporary copy of the ordinary booking that can me manipulated and later merged in to the original.
     * @param {string} bookingNumber The booking number of the booking to rebook.
     * @param {CloneBookingDto} [cloneBookingDto] Information used for verifying the identity of the customer (email / phone).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.cloneBooking = function (bookingNumber, cloneBookingDto, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).cloneBooking(bookingNumber, cloneBookingDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint tries to create a new temporary booking, to be filled in with future request.  If a temporary booking already exist, that booking will be returned.  A temporary booking has a lifespan of about 30 minutes. That counter is reset with every action made to the booking
     * @param {CreateBookingDto} createBookingDto The plate number of the first vehicle in the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.createBooking = function (createBookingDto, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).createBooking(createBookingDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint deletes a uncompleted booking
     * @param {string} bookingNumber The booking number of the temporary booking to cancel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.exitBooking = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).exitBooking(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves the ACPM price for the given parameters
     * @param {string} regno The regNo of the vehicle to get the price for
     * @param {number} productId The id of the product.
     * @param {string} dateTime The start time and date.
     * @param {number} stationId The id of the station.
     * @param {ACPMPriceType} priceTypeId The id of the price type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getACPMPrice = function (regno, productId, dateTime, stationId, priceTypeId, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getACPMPrice(regno, productId, dateTime, stationId, priceTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves the ACPM price rule texts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getACPMPriceRuleTexts = function (options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getACPMPriceRuleTexts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets basic information about all available products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getAllProducts = function (options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getAllProducts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary The get available products for booking.
     * @param {string} bookingNumber The booking number.
     * @param {string} regno The plate number of the vehicle to display products for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getAvailableProductsForBooking = function (bookingNumber, regno, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getAvailableProductsForBooking(bookingNumber, regno, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves the available times for the booking based on the given search parameters
     * @param {string} bookingNumber The booking number of the booking to get the available times for
     * @param {Array<number>} stationIds The station Ids.
     * @param {string} start The start.
     * @param {string} end The end.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getAvailableTimesForBooking = function (bookingNumber, stationIds, start, end, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getAvailableTimesForBooking(bookingNumber, stationIds, start, end, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves a booking by booking number. The result can be a completed booking, a confirmed future  booking or a ongoing temporary booking.
     * @param {string} bookingNumber The booking number of the booking to retrieve. It has the format (B123456)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getBooking = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getBooking(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves a booking by sso key. The result can be a completed booking, a confirmed future booking or  a ongoing temporary booking.
     * @param {string} key The sso key for the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getBookingFromSsoKey = function (key, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getBookingFromSsoKey(key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets dates and status of future bookings of the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getBookings = function (options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getBookings(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves information about the consequences of cancelling the booking
     * @param {string} bookingNumber The booking number of the booking to get the cancellation info for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getCancelBookingInfo = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getCancelBookingInfo(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
     * @param {string} bookingNumber The booking number of the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getConfirmationPrintOut = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getConfirmationPrintOut(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint created ans returns a *.ics file with calendar information about the booking
     * @param {string} bookingNumber The booking number of the booking to base the *.ics file on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getICal = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getICal(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is responsible for retrieving available payment options for the booking with the given booking number
     * @param {string} bookingNumber The booking number of the booking to get the payment options for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getPaymentOptions = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getPaymentOptions(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary The get stations for booking.
     * @param {string} bookingNumber The booking number.
     * @param {number} [lat] The lat.
     * @param {number} [lon] The lon.
     * @param {number} [radius] The radius to search around. If not assigned it will default to int.Max (aka. All stations)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getSuggestedStationsForBooking = function (bookingNumber, lat, lon, radius, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getSuggestedStationsForBooking(bookingNumber, lat, lon, radius, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets the bookings on a specific vehicle both temporary and ordinary
     * @param {string} regno The plate number of the vehicle to match the future booking with.
     * @param {boolean} [ignorePassedBookings] If the search should ignore last bookings
     * @param {boolean} [includeUncompleted] If the response should contain temporary bookings that have been started but not  completed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.getVehicleBookings = function (regno, ignorePassedBookings, includeUncompleted, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).getVehicleBookings(regno, ignorePassedBookings, includeUncompleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint keeps the time that is currently on the booking, but recalculates the price
     * @param {string} bookingNumber The booking number of the booking to keep the time on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.keepTimeForBooking = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).keepTimeForBooking(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used to get the klarna confirmation page snippet
     * @param {string} orderId Klarna order id
     * @param {string} bookingNumber Booking number of the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.klarnaConfirmation = function (orderId, bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).klarnaConfirmation(orderId, bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} orderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.klarnaPushNotification = function (orderId, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).klarnaPushNotification(orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is responsible for opening up payment for the booking with the given booking number
     * @param {string} bookingNumber The booking number of the booking to open payment for
     * @param {PayBookingDto} payBookingDto Stringfied Json object containing information needed for the chosen payment method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.payBooking = function (bookingNumber, payBookingDto, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).payBooking(bookingNumber, payBookingDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is to be called when a payment failure occured on a booking
     * @param {string} bookingNumber The booking number of the booking that the payment failed on
     * @param {string} [orderId] Klarna order id in case the endpoint is used when a klarna payment failed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.paymentFailed = function (bookingNumber, orderId, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).paymentFailed(bookingNumber, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint sends an extra confirmation email to the provided email when confirming the booking
     * @param {string} bookingNumber The booking number of the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.sendConfirmation = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).sendConfirmation(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoints attempts to att a campaign code to a booking
     * @param {string} bookingNumber The booking number of the booking to edit
     * @param {SetCampaignCodeDto} [setCampaignCodeDto] The campaign code to add
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.setCampaignCode = function (bookingNumber, setCampaignCodeDto, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).setCampaignCode(bookingNumber, setCampaignCodeDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is used for setting the products for the given booking
     * @param {string} bookingNumber The booking number of the given booking to update
     * @param {SetProducts} setProducts Information about the selected products on the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.setProducts = function (bookingNumber, setProducts, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).setProducts(bookingNumber, setProducts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint selects a time that is previously retrieved with the [GET bookingNumber}/availableTimes]
     * @param {string} bookingNumber The booking number of the booking to select the time for
     * @param {SelectTime} selectTime The time and data info to set to the booking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.setTimeForBooking = function (bookingNumber, selectTime, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).setTimeForBooking(bookingNumber, selectTime, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint is responsible for updating the payment for the booking with the given booking number
     * @param {string} bookingNumber The booking number of the booking to open payment for
     * @param {string} orderId The klarna order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.updatePayBooking = function (bookingNumber, orderId, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).updatePayBooking(bookingNumber, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint extends the life time of the temporary booking
     * @param {string} bookingNumber The booking number of the booking. It has the format (B123456)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingsApi
     */
    BookingsApi.prototype.updateSession = function (bookingNumber, options) {
        var _this = this;
        return (0, exports.BookingsApiFp)(this.configuration).updateSession(bookingNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BookingsApi;
}(base_1.BaseAPI));
exports.BookingsApi = BookingsApi;
/**
 * ConversionTrackingApi - axios parameter creator
 * @export
 */
var ConversionTrackingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary send event to facebook
         * @param {FacebookEventDto} facebookEventDto Information about the event to send to facebook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackEvent: function (facebookEventDto, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'facebookEventDto' is not null or undefined
                            (0, common_1.assertParamExists)('trackEvent', 'facebookEventDto', facebookEventDto);
                            localVarPath = "/api/ConversionTracking/trackevent";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(facebookEventDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ConversionTrackingApiAxiosParamCreator = ConversionTrackingApiAxiosParamCreator;
/**
 * ConversionTrackingApi - functional programming interface
 * @export
 */
var ConversionTrackingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ConversionTrackingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary send event to facebook
         * @param {FacebookEventDto} facebookEventDto Information about the event to send to facebook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackEvent: function (facebookEventDto, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.trackEvent(facebookEventDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ConversionTrackingApiFp = ConversionTrackingApiFp;
/**
 * ConversionTrackingApi - factory interface
 * @export
 */
var ConversionTrackingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ConversionTrackingApiFp)(configuration);
    return {
        /**
         *
         * @summary send event to facebook
         * @param {FacebookEventDto} facebookEventDto Information about the event to send to facebook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackEvent: function (facebookEventDto, options) {
            return localVarFp.trackEvent(facebookEventDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ConversionTrackingApiFactory = ConversionTrackingApiFactory;
/**
 * ConversionTrackingApi - object-oriented interface
 * @export
 * @class ConversionTrackingApi
 * @extends {BaseAPI}
 */
var ConversionTrackingApi = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ConversionTrackingApi, _super);
    function ConversionTrackingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary send event to facebook
     * @param {FacebookEventDto} facebookEventDto Information about the event to send to facebook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversionTrackingApi
     */
    ConversionTrackingApi.prototype.trackEvent = function (facebookEventDto, options) {
        var _this = this;
        return (0, exports.ConversionTrackingApiFp)(this.configuration).trackEvent(facebookEventDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ConversionTrackingApi;
}(base_1.BaseAPI));
exports.ConversionTrackingApi = ConversionTrackingApi;
/**
 * StationsApi - axios parameter creator
 * @export
 */
var StationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Gets a specific station
         * @param {number} id Id of the station to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStation: function (id, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getStation', 'id', id);
                            localVarPath = "/api/stations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a specific station open hours info
         * @param {number} id Id of the station to retrieve
         * @param {string} [date] A date of the week of what the open hours are to be based
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationOpenHoursAndInfo: function (id, date, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getStationOpenHoursAndInfo', 'id', id);
                            localVarPath = "/api/stations/{id}/openHours"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (date !== undefined) {
                                localVarQueryParameter['date'] = (date instanceof Date) ?
                                    date.toISOString() :
                                    date;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all active stations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStations: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/stations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the coordinate that match the given search criteria
         * @param {string} [search] The search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocation: function (search, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/stations/coordinate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StationsApiAxiosParamCreator = StationsApiAxiosParamCreator;
/**
 * StationsApi - functional programming interface
 * @export
 */
var StationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Gets a specific station
         * @param {number} id Id of the station to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStation: function (id, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStation(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a specific station open hours info
         * @param {number} id Id of the station to retrieve
         * @param {string} [date] A date of the week of what the open hours are to be based
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationOpenHoursAndInfo: function (id, date, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStationOpenHoursAndInfo(id, date, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves all active stations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStations: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStations(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint retrieves the coordinate that match the given search criteria
         * @param {string} [search] The search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocation: function (search, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchLocation(search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.StationsApiFp = StationsApiFp;
/**
 * StationsApi - factory interface
 * @export
 */
var StationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Gets a specific station
         * @param {number} id Id of the station to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStation: function (id, options) {
            return localVarFp.getStation(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets a specific station open hours info
         * @param {number} id Id of the station to retrieve
         * @param {string} [date] A date of the week of what the open hours are to be based
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationOpenHoursAndInfo: function (id, date, options) {
            return localVarFp.getStationOpenHoursAndInfo(id, date, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves all active stations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStations: function (options) {
            return localVarFp.getStations(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint retrieves the coordinate that match the given search criteria
         * @param {string} [search] The search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocation: function (search, options) {
            return localVarFp.searchLocation(search, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StationsApiFactory = StationsApiFactory;
/**
 * StationsApi - object-oriented interface
 * @export
 * @class StationsApi
 * @extends {BaseAPI}
 */
var StationsApi = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(StationsApi, _super);
    function StationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets a specific station
     * @param {number} id Id of the station to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.getStation = function (id, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).getStation(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets a specific station open hours info
     * @param {number} id Id of the station to retrieve
     * @param {string} [date] A date of the week of what the open hours are to be based
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.getStationOpenHoursAndInfo = function (id, date, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).getStationOpenHoursAndInfo(id, date, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves all active stations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.getStations = function (options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).getStations(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint retrieves the coordinate that match the given search criteria
     * @param {string} [search] The search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationsApi
     */
    StationsApi.prototype.searchLocation = function (search, options) {
        var _this = this;
        return (0, exports.StationsApiFp)(this.configuration).searchLocation(search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StationsApi;
}(base_1.BaseAPI));
exports.StationsApi = StationsApi;
/**
 * VehiclesApi - axios parameter creator
 * @export
 */
var VehiclesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} regno
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserIdentity: function (regno, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('assignUserIdentity', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}/assignUser"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a csv file of vehicles associated with the user with pagination through a filter
         * @param {number} page
         * @param {number} pageSize
         * @param {string} [regNo]
         * @param {string} [orgNo]
         * @param {boolean} [isDrivingBan]
         * @param {boolean} [isInTraffic]
         * @param {string} [lastInspectionMonth]
         * @param {string} [alias]
         * @param {string} [vehicleType]
         * @param {boolean} [saveAsXls] The save As Xls.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsvVehiclesWithFilter: function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('getCsvVehiclesWithFilter', 'page', page);
                            // verify required parameter 'pageSize' is not null or undefined
                            (0, common_1.assertParamExists)('getCsvVehiclesWithFilter', 'pageSize', pageSize);
                            localVarPath = "/api/vehicles/csv";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (regNo !== undefined) {
                                localVarQueryParameter['RegNo'] = regNo;
                            }
                            if (orgNo !== undefined) {
                                localVarQueryParameter['OrgNo'] = orgNo;
                            }
                            if (isDrivingBan !== undefined) {
                                localVarQueryParameter['IsDrivingBan'] = isDrivingBan;
                            }
                            if (isInTraffic !== undefined) {
                                localVarQueryParameter['IsInTraffic'] = isInTraffic;
                            }
                            if (lastInspectionMonth !== undefined) {
                                localVarQueryParameter['LastInspectionMonth'] = (lastInspectionMonth instanceof Date) ?
                                    lastInspectionMonth.toISOString() :
                                    lastInspectionMonth;
                            }
                            if (alias !== undefined) {
                                localVarQueryParameter['Alias'] = alias;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['PageSize'] = pageSize;
                            }
                            if (vehicleType !== undefined) {
                                localVarQueryParameter['VehicleType'] = vehicleType;
                            }
                            if (saveAsXls !== undefined) {
                                localVarQueryParameter['saveAsXls'] = saveAsXls;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint gets the inspection documents for a vehicle
         * @param {string} regno The plate number of the vehicle to return the inspection documents for
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionDocuments: function (regno, from, to, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getInspectionDocuments', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}/inspectionDocuments"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (from !== undefined) {
                                localVarQueryParameter['From'] = (from instanceof Date) ?
                                    from.toISOString() :
                                    from;
                            }
                            if (to !== undefined) {
                                localVarQueryParameter['To'] = (to instanceof Date) ?
                                    to.toISOString() :
                                    to;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets additional information about a vehicle that can be manipulated
         * @param {string} regno The plate number of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVehicleInfo: function (regno, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getUserVehicleInfo', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}/info"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets basic information about a vehicle based of the plate number of the vehicle
         * @param {string} regno The plate number of the vehicle to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle: function (regno, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getVehicle', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets owner information from Bisnode about a vehicle based of the plate number of the vehicle
         * @param {string} regno The plate number of the vehicle to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleWithDetails: function (regno, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('getVehicleWithDetails', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}/details"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets all the vehicles associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicles: function (options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/vehicles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets basic information about the vehicles owned by a given array of user identities
         * @param {Array<string>} userIdentities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesByUserIdentities: function (userIdentities, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userIdentities' is not null or undefined
                            (0, common_1.assertParamExists)('getVehiclesByUserIdentities', 'userIdentities', userIdentities);
                            localVarPath = "/api/vehicles/vehiclesByUserIdentities";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (userIdentities) {
                                localVarQueryParameter['userIdentities'] = userIdentities;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets vehicles associated with the given alias on the user
         * @param {string} [alias]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesFromAlias: function (alias, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/vehicles/alias";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (alias !== undefined) {
                                localVarQueryParameter['alias'] = alias;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a xlsx file of vehicles associated with the user with pagination through a filter
         * @param {number} page
         * @param {number} pageSize
         * @param {string} [regNo]
         * @param {string} [orgNo]
         * @param {boolean} [isDrivingBan]
         * @param {boolean} [isInTraffic]
         * @param {string} [lastInspectionMonth]
         * @param {string} [alias]
         * @param {string} [vehicleType]
         * @param {string} [token] JWT Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsxVehiclesWithFilter: function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('getXlsxVehiclesWithFilter', 'page', page);
                            // verify required parameter 'pageSize' is not null or undefined
                            (0, common_1.assertParamExists)('getXlsxVehiclesWithFilter', 'pageSize', pageSize);
                            localVarPath = "/api/vehicles/xlsx";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (regNo !== undefined) {
                                localVarQueryParameter['RegNo'] = regNo;
                            }
                            if (orgNo !== undefined) {
                                localVarQueryParameter['OrgNo'] = orgNo;
                            }
                            if (isDrivingBan !== undefined) {
                                localVarQueryParameter['IsDrivingBan'] = isDrivingBan;
                            }
                            if (isInTraffic !== undefined) {
                                localVarQueryParameter['IsInTraffic'] = isInTraffic;
                            }
                            if (lastInspectionMonth !== undefined) {
                                localVarQueryParameter['LastInspectionMonth'] = (lastInspectionMonth instanceof Date) ?
                                    lastInspectionMonth.toISOString() :
                                    lastInspectionMonth;
                            }
                            if (alias !== undefined) {
                                localVarQueryParameter['Alias'] = alias;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['PageSize'] = pageSize;
                            }
                            if (vehicleType !== undefined) {
                                localVarQueryParameter['VehicleType'] = vehicleType;
                            }
                            if (token !== undefined) {
                                localVarQueryParameter['token'] = token;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Validate a Case number from Transportstyrelsen
         * @param {string} caseno The case number from TS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCaseNumberValid: function (caseno, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'caseno' is not null or undefined
                            (0, common_1.assertParamExists)('isCaseNumberValid', 'caseno', caseno);
                            localVarPath = "/api/vehicles/{caseno}/isValidCaseNumber"
                                .replace("{".concat("caseno", "}"), encodeURIComponent(String(caseno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint saves contact information of a vehicle
         * @param {string} regno The plate number of the vehicle
         * @param {SetContactInformation} [setContactInformation] The contact information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setContactInfo: function (regno, setContactInformation, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('setContactInfo', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}/contactInfo"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setContactInformation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint saves note information of a vehicle
         * @param {string} regno The plate number of the vehicle to store the notes on
         * @param {SetNoteInformation} setNoteInformation The note information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotes: function (regno, setNoteInformation, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('setNotes', 'regno', regno);
                            // verify required parameter 'setNoteInformation' is not null or undefined
                            (0, common_1.assertParamExists)('setNotes', 'setNoteInformation', setNoteInformation);
                            localVarPath = "/api/vehicles/{regno}/notes"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setNoteInformation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint saves notification information of a vehicle
         * @param {string} regno The plate number of the vehicle
         * @param {SetNotificationInformation} [setNotificationInformation] The notification information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotifications: function (regno, setNotificationInformation, options) {
            if (options === void 0) { options = {}; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'regno' is not null or undefined
                            (0, common_1.assertParamExists)('setNotifications', 'regno', regno);
                            localVarPath = "/api/vehicles/{regno}/notifications"
                                .replace("{".concat("regno", "}"), encodeURIComponent(String(regno)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = (0, tslib_1.__assign)((0, tslib_1.__assign)({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setNotificationInformation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VehiclesApiAxiosParamCreator = VehiclesApiAxiosParamCreator;
/**
 * VehiclesApi - functional programming interface
 * @export
 */
var VehiclesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VehiclesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} regno
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserIdentity: function (regno, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.assignUserIdentity(regno, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a csv file of vehicles associated with the user with pagination through a filter
         * @param {number} page
         * @param {number} pageSize
         * @param {string} [regNo]
         * @param {string} [orgNo]
         * @param {boolean} [isDrivingBan]
         * @param {boolean} [isInTraffic]
         * @param {string} [lastInspectionMonth]
         * @param {string} [alias]
         * @param {string} [vehicleType]
         * @param {boolean} [saveAsXls] The save As Xls.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsvVehiclesWithFilter: function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCsvVehiclesWithFilter(page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint gets the inspection documents for a vehicle
         * @param {string} regno The plate number of the vehicle to return the inspection documents for
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionDocuments: function (regno, from, to, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInspectionDocuments(regno, from, to, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets additional information about a vehicle that can be manipulated
         * @param {string} regno The plate number of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVehicleInfo: function (regno, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserVehicleInfo(regno, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets basic information about a vehicle based of the plate number of the vehicle
         * @param {string} regno The plate number of the vehicle to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle: function (regno, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVehicle(regno, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets owner information from Bisnode about a vehicle based of the plate number of the vehicle
         * @param {string} regno The plate number of the vehicle to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleWithDetails: function (regno, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVehicleWithDetails(regno, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets all the vehicles associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicles: function (options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVehicles(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets basic information about the vehicles owned by a given array of user identities
         * @param {Array<string>} userIdentities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesByUserIdentities: function (userIdentities, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVehiclesByUserIdentities(userIdentities, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets vehicles associated with the given alias on the user
         * @param {string} [alias]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesFromAlias: function (alias, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVehiclesFromAlias(alias, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets a xlsx file of vehicles associated with the user with pagination through a filter
         * @param {number} page
         * @param {number} pageSize
         * @param {string} [regNo]
         * @param {string} [orgNo]
         * @param {boolean} [isDrivingBan]
         * @param {boolean} [isInTraffic]
         * @param {string} [lastInspectionMonth]
         * @param {string} [alias]
         * @param {string} [vehicleType]
         * @param {string} [token] JWT Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsxVehiclesWithFilter: function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getXlsxVehiclesWithFilter(page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Validate a Case number from Transportstyrelsen
         * @param {string} caseno The case number from TS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCaseNumberValid: function (caseno, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.isCaseNumberValid(caseno, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint saves contact information of a vehicle
         * @param {string} regno The plate number of the vehicle
         * @param {SetContactInformation} [setContactInformation] The contact information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setContactInfo: function (regno, setContactInformation, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setContactInfo(regno, setContactInformation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint saves note information of a vehicle
         * @param {string} regno The plate number of the vehicle to store the notes on
         * @param {SetNoteInformation} setNoteInformation The note information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotes: function (regno, setNoteInformation, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setNotes(regno, setNoteInformation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary This endpoint saves notification information of a vehicle
         * @param {string} regno The plate number of the vehicle
         * @param {SetNotificationInformation} [setNotificationInformation] The notification information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotifications: function (regno, setNotificationInformation, options) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setNotifications(regno, setNotificationInformation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VehiclesApiFp = VehiclesApiFp;
/**
 * VehiclesApi - factory interface
 * @export
 */
var VehiclesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VehiclesApiFp)(configuration);
    return {
        /**
         *
         * @param {string} regno
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUserIdentity: function (regno, options) {
            return localVarFp.assignUserIdentity(regno, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets a csv file of vehicles associated with the user with pagination through a filter
         * @param {number} page
         * @param {number} pageSize
         * @param {string} [regNo]
         * @param {string} [orgNo]
         * @param {boolean} [isDrivingBan]
         * @param {boolean} [isInTraffic]
         * @param {string} [lastInspectionMonth]
         * @param {string} [alias]
         * @param {string} [vehicleType]
         * @param {boolean} [saveAsXls] The save As Xls.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsvVehiclesWithFilter: function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options) {
            return localVarFp.getCsvVehiclesWithFilter(page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint gets the inspection documents for a vehicle
         * @param {string} regno The plate number of the vehicle to return the inspection documents for
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionDocuments: function (regno, from, to, options) {
            return localVarFp.getInspectionDocuments(regno, from, to, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets additional information about a vehicle that can be manipulated
         * @param {string} regno The plate number of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVehicleInfo: function (regno, options) {
            return localVarFp.getUserVehicleInfo(regno, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets basic information about a vehicle based of the plate number of the vehicle
         * @param {string} regno The plate number of the vehicle to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle: function (regno, options) {
            return localVarFp.getVehicle(regno, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets owner information from Bisnode about a vehicle based of the plate number of the vehicle
         * @param {string} regno The plate number of the vehicle to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleWithDetails: function (regno, options) {
            return localVarFp.getVehicleWithDetails(regno, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets all the vehicles associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicles: function (options) {
            return localVarFp.getVehicles(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets basic information about the vehicles owned by a given array of user identities
         * @param {Array<string>} userIdentities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesByUserIdentities: function (userIdentities, options) {
            return localVarFp.getVehiclesByUserIdentities(userIdentities, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets vehicles associated with the given alias on the user
         * @param {string} [alias]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehiclesFromAlias: function (alias, options) {
            return localVarFp.getVehiclesFromAlias(alias, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets a xlsx file of vehicles associated with the user with pagination through a filter
         * @param {number} page
         * @param {number} pageSize
         * @param {string} [regNo]
         * @param {string} [orgNo]
         * @param {boolean} [isDrivingBan]
         * @param {boolean} [isInTraffic]
         * @param {string} [lastInspectionMonth]
         * @param {string} [alias]
         * @param {string} [vehicleType]
         * @param {string} [token] JWT Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXlsxVehiclesWithFilter: function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options) {
            return localVarFp.getXlsxVehiclesWithFilter(page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Validate a Case number from Transportstyrelsen
         * @param {string} caseno The case number from TS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCaseNumberValid: function (caseno, options) {
            return localVarFp.isCaseNumberValid(caseno, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint saves contact information of a vehicle
         * @param {string} regno The plate number of the vehicle
         * @param {SetContactInformation} [setContactInformation] The contact information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setContactInfo: function (regno, setContactInformation, options) {
            return localVarFp.setContactInfo(regno, setContactInformation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint saves note information of a vehicle
         * @param {string} regno The plate number of the vehicle to store the notes on
         * @param {SetNoteInformation} setNoteInformation The note information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotes: function (regno, setNoteInformation, options) {
            return localVarFp.setNotes(regno, setNoteInformation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary This endpoint saves notification information of a vehicle
         * @param {string} regno The plate number of the vehicle
         * @param {SetNotificationInformation} [setNotificationInformation] The notification information model to fill out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNotifications: function (regno, setNotificationInformation, options) {
            return localVarFp.setNotifications(regno, setNotificationInformation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VehiclesApiFactory = VehiclesApiFactory;
/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
var VehiclesApi = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VehiclesApi, _super);
    function VehiclesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} regno
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.assignUserIdentity = function (regno, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).assignUserIdentity(regno, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets a csv file of vehicles associated with the user with pagination through a filter
     * @param {number} page
     * @param {number} pageSize
     * @param {string} [regNo]
     * @param {string} [orgNo]
     * @param {boolean} [isDrivingBan]
     * @param {boolean} [isInTraffic]
     * @param {string} [lastInspectionMonth]
     * @param {string} [alias]
     * @param {string} [vehicleType]
     * @param {boolean} [saveAsXls] The save As Xls.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getCsvVehiclesWithFilter = function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getCsvVehiclesWithFilter(page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, saveAsXls, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint gets the inspection documents for a vehicle
     * @param {string} regno The plate number of the vehicle to return the inspection documents for
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getInspectionDocuments = function (regno, from, to, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getInspectionDocuments(regno, from, to, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets additional information about a vehicle that can be manipulated
     * @param {string} regno The plate number of the vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getUserVehicleInfo = function (regno, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getUserVehicleInfo(regno, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets basic information about a vehicle based of the plate number of the vehicle
     * @param {string} regno The plate number of the vehicle to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getVehicle = function (regno, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getVehicle(regno, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets owner information from Bisnode about a vehicle based of the plate number of the vehicle
     * @param {string} regno The plate number of the vehicle to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getVehicleWithDetails = function (regno, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getVehicleWithDetails(regno, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets all the vehicles associated with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getVehicles = function (options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getVehicles(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets basic information about the vehicles owned by a given array of user identities
     * @param {Array<string>} userIdentities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getVehiclesByUserIdentities = function (userIdentities, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getVehiclesByUserIdentities(userIdentities, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets vehicles associated with the given alias on the user
     * @param {string} [alias]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getVehiclesFromAlias = function (alias, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getVehiclesFromAlias(alias, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets a xlsx file of vehicles associated with the user with pagination through a filter
     * @param {number} page
     * @param {number} pageSize
     * @param {string} [regNo]
     * @param {string} [orgNo]
     * @param {boolean} [isDrivingBan]
     * @param {boolean} [isInTraffic]
     * @param {string} [lastInspectionMonth]
     * @param {string} [alias]
     * @param {string} [vehicleType]
     * @param {string} [token] JWT Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.getXlsxVehiclesWithFilter = function (page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).getXlsxVehiclesWithFilter(page, pageSize, regNo, orgNo, isDrivingBan, isInTraffic, lastInspectionMonth, alias, vehicleType, token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Validate a Case number from Transportstyrelsen
     * @param {string} caseno The case number from TS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.isCaseNumberValid = function (caseno, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).isCaseNumberValid(caseno, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint saves contact information of a vehicle
     * @param {string} regno The plate number of the vehicle
     * @param {SetContactInformation} [setContactInformation] The contact information model to fill out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.setContactInfo = function (regno, setContactInformation, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).setContactInfo(regno, setContactInformation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint saves note information of a vehicle
     * @param {string} regno The plate number of the vehicle to store the notes on
     * @param {SetNoteInformation} setNoteInformation The note information model to fill out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.setNotes = function (regno, setNoteInformation, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).setNotes(regno, setNoteInformation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary This endpoint saves notification information of a vehicle
     * @param {string} regno The plate number of the vehicle
     * @param {SetNotificationInformation} [setNotificationInformation] The notification information model to fill out
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    VehiclesApi.prototype.setNotifications = function (regno, setNotificationInformation, options) {
        var _this = this;
        return (0, exports.VehiclesApiFp)(this.configuration).setNotifications(regno, setNotificationInformation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VehiclesApi;
}(base_1.BaseAPI));
exports.VehiclesApi = VehiclesApi;
